import React from 'react';
import { FlattedCategory } from '@/types/category';
import LabelBadge from "@/components/UiElements/LabelBadge";



interface CategoryStatusProps {
    category: FlattedCategory;
}

const CategoryStatus: React.FC<CategoryStatusProps> = ({ category }) => {
    return (
        <div className="flex flex-row gap-xs">
            {/*<Button

                className={"flex flex-col gap-sm justify-start  !py-[8px] !h-auto  !px-4  rounded-md text-left !shadow-none"}>
                <>
                    <p className='text-white text-xs font-icon-solid '>
                        
                    </p>
                    <p className='text-white text-xs'>
                        Edit
                    </p>
                </>
            </Button>*/}

            {category.showOnHome &&
                <LabelBadge label={<span className="font-icon-solid "></span>} parentClassName="!bg-gray-100">
                    Show On Home
                </LabelBadge>
            }
            {category.isActive &&
                <LabelBadge label={<span className="font-icon-solid "></span>} parentClassName="!bg-gray-100">
                    Active
                </LabelBadge>
            }
            {!category.isActive &&
                <LabelBadge label={<span className="font-icon-solid "></span>} parentClassName="!bg-gray-100">
                    Inactive
                </LabelBadge>

            }
            {( category.childCategory && category.childCategory > 0) &&
                <LabelBadge label={<span className="font-icon-solid "></span>} parentClassName="!bg-gray-100">
                    <b>{category.childCategory}</b> {category.childCategory > 1 ? "Subcategories" : "Subcategory"}
                </LabelBadge>

            }
            {(category.childCount && category.childCount > 0) ?
                <LabelBadge label={<span className="font-icon-solid "></span>} parentClassName="!bg-gray-100">
                    <b>{category.childCount}</b> Element{category.childCount > 1 ? "s" : ""}
                </LabelBadge>
                :
                <LabelBadge label={<span className="font-icon-solid "></span>} parentClassName="!bg-gray-100">
                    Empty
                </LabelBadge>
            }


        </div>
    );
};

export default CategoryStatus;
